import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";
import FilterSingleSelectDropdown from "../../components/filterDropdown/FilterSingleSelectDropdown";
import DateRangeFilter from "../../components/filterDropdown/DateRangeFilter";
import { SnackbarData, SnackbarType } from "../../components/Snackbar";
import { generateUniqueNumber } from "../../shared/utility";

export function CycleCountsViewModel(logout, addSnackbar) {
  const [filters, setFilters] = useState({
    warehouse_location: { value: -1, label: "All locations" },
    startDate: null,
    endDate: null,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [cycleCounts, setCycleCounts] = useState([]);
  const [totalCycleCounts, setTotalCycleCounts] = useState([]);
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [reportInProgress, setReportInProgress] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [showReports, setShowReports] = useState(false);
  const [warehouseLocations, setWarehouseLocations] = useState(false);

  const getCycleCounts = async function (search, page, filter) {
    const payload = {
      page: page,
      search: search,
      filter: filter,
    };
    setLoading(true);
    let callResult = await makePostApiCall(`cycleCounts`, payload);
    if (callResult.success) {
      const response = callResult.data;
      if (page > 1) {
        setCycleCounts([...cycleCounts, ...response.data]);
      } else {
        setLoading(false);
        setCycleCounts(response.data);
        setTotalCycleCounts(response.total);
      }
      setLoading(false);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
    setLoading(false);
  };

  const deleteCycleCount = async function (cycleCountId) {
    let callResult = await makePostApiCall(
      `deleteCycleCount/${cycleCountId}`,
      {},
    );
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getCycleCounts(null, 0, filters);

      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteCycleCount = function (cycleCount, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteCycleCount(cycleCount.id)}
          message={`Are you sure you want to delete cycle count ${cycleCount.name} in room ${cycleCount.warehouse_location_name}?`}
          hideReason={true}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  const getWarehouseLocations = async function () {
    let callResult = await makeGetApiCall(`warehouseLocationsForDropdown/2`);
    if (callResult.success) {
      setWarehouseLocations(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const filterComponents = [
    <DateRangeFilter
      startDate={filters.startDate}
      endDate={filters.endDate}
      onChange={(name, value) =>
        setFilters({
          ...filters,
          [name]: value,
        })
      }
      resetFilter={() =>
        setFilters({
          ...filters,
          startDate: null,
          endDate: null,
        })
      }
    />,
    <FilterSingleSelectDropdown
      header="Location"
      onChange={(value) =>
        setFilters({
          ...filters,
          warehouse_location: value,
        })
      }
      options={warehouseLocations}
      resetFilter={() =>
        setFilters({
          ...filters,
          warehouse_location: { value: -1, label: "All locations" },
        })
      }
      valueName="warehouse_location"
      value={filters.warehouse_location}
    />,
  ];

  const resetFilters = () => {
    const filterReset = {
      warehouse_location: { value: -1, label: "All locations" },
      startDate: null,
      endDate: null,
    };
    setFilters(filterReset);

    setShowFilters(false);
    getCycleCounts(null, 1, filterReset);
  };

  return {
    askDeleteCycleCount,
    emptyModal,
    getCycleCounts,
    loading,
    cycleCounts,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    showReports,
    setShowReports,
    reportInProgress,
    showFilters,
    setShowFilters,
    filters,
    filterComponents,
    resetFilters,
    getWarehouseLocations,
    totalCycleCounts,
  };
}
